/** @format */

import React from 'react';
// Custom components
import {BannerBtn, Default} from '../index';
// Material UI
import Typography from '@material-ui/core/Typography';
import {styled} from '@material-ui/core/styles';

//#region Styled components
const MainTxt = styled(Typography)(
  {
    color: '#fff',
    fontFamily: 'Barlow Condensed, Roboto, sans-serif',
    fontSize: '2.25rem',
    fontWeight: '400',
    letterSpacing: '0',
    lineHeight: '1',
    marginBottom: '3rem',
    userSelect: 'none',
    width: '50rem',
    '&.line1': {
      fontSize: '3rem',
      marginBottom: '0',
      '&.mbl': {
        fontSize: '9rem',
      },
    },
    '&.line2': {
      fontSize: '8rem',
      fontWeight: '700',
      marginBottom: '3.5rem',
      '&.mbl': {
        fontSize: '10rem',
      },
    },
    '&.line3': {
      fontSize: '3.25rem',
      fontWeight: '600',
      marginBottom: '5rem',
      '&.mbl': {
        width:'100%',
        fontSize: '9rem',
      },
    },
    '&.line4': {
      fontSize: '3rem',
      marginBottom: '5rem',
      '&.mbl': {
        fontSize: '9rem',
        width:"100%",
        textAlign:'justify'
      },
    },
  },
  {name: 'main-txt'}
);
//#endregion

export default function MerchBanner({isMobile}) {
  return (
    <Default
      justifyTxt="flex-end"
      bgColor="#000"
      mainImgSrc="https://cdn.sunsh1n3.com/home/Premium%20Spool.png"
      // mainImgStyles={{
      //   flex: 2,
      // }}
      textLoc={isMobile?"top":"left"}
      isMobile={isMobile}
      txtStyles={{
        marginRight: isMobile ? '0 ' : '-15%',
      }}>
      <img src={`https://cdn.sunsh1n3.com/home/Premium%20Logo.png?w=${isMobile?100:200}`} alt="Premium Logo" />
      <MainTxt align="center" variant="h2" className={`line3 ${isMobile ? 'mbl' : ''}`}>
        Experience PrintBed Premium
      </MainTxt>
      <MainTxt align="center" className={`line4 ${isMobile ? 'mbl' : ''}`}>
        PrintBed launches an exclusive color each month which gets delivered to Premium members for just $25/month. These exclusive colors consist of special blends and even 3D filaments that glow in the dark. Premium members also receive additional benefits including 10% off other filaments, free ground shipping, the ability to vote for new colors, and mystery spools with new R&D colors.      </MainTxt>
      <BannerBtn
        colorVariant="white"
        custHeight={isMobile ? '20rem' : undefined}
        custWidth={isMobile ? '' : undefined}
        fontSize={isMobile ? '8rem' : '2.75rem'}
        fontWeight="400"
        txtColor="#000"
        to="/premium/">
        Get Premium
      </BannerBtn>
    </Default>
  );
}
